import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase, verifyAdminUser } from '../../lib/supabase';
import '../../admin.css';

export function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;

    const evaluate = async (session) => {
      if (cancelled) return;

      if (!session?.user) {
        setStatus('guest');
        return;
      }

      setStatus('loading');
      try {
        const isAdmin = await verifyAdminUser(session.user.id);
        if (!cancelled) setStatus(isAdmin ? 'admin' : 'guest');
      } catch {
        if (!cancelled) setStatus('guest');
      }
    };

    const timeout = setTimeout(() => {
      if (!cancelled) {
        setStatus((current) => (current === 'loading' ? 'guest' : current));
      }
    }, 4000);

    supabase.auth
      .getSession()
      .then(({ data }) => evaluate(data.session))
      .catch(() => {
        if (!cancelled) setStatus('guest');
      });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      evaluate(session);
    });

    return () => {
      cancelled = true;
      clearTimeout(timeout);
      subscription.unsubscribe();
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="admin-loading-screen">
        <p>Loading…</p>
      </div>
    );
  }

  if (status !== 'admin') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
